import React, {ChangeEvent, DragEvent, useEffect, useRef, useState} from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { Button, Icon } from "semantic-ui-react"
import {useNavigate} from "react-router"
import {toChart} from "../converter/create-gedcom-backend"
import * as Sentry from "@sentry/react"


const allowedExtensions = [".ged", ".gdz", ".gedzip"]

export const Dropzone = () => {
    const intl = useIntl()
    const navigate = useNavigate()
    const fileInputRef = useRef<HTMLInputElement | null>(null)
    const [file, setFile] = useState<File | null>()
    const [error, setError] = useState<string | null>()

    useEffect(() => {
        if (!file) return
        ;(async () => {
            const extra = await file.text()
            console.log(`Uploaded '${file.name}' valid. Loading chart...`)
            Sentry.captureMessage(`[MOBILE] Uploaded '${file.name}' valid.`, { level: "log", extra: { file: extra }})
            await toChart(file, navigate)
        })()
    })

    const handleUploadClick = () => {
        fileInputRef.current?.click()
    }

    const handleUploadDrop = async (event: DragEvent<HTMLDivElement>) => {
        event.preventDefault()
        if (event.dataTransfer.files.length > 0) {
            await handleFile(event.dataTransfer.files[0])
        }
    }

    const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            await handleFile(event.target.files[0])
        }
    }

    const handleFile = async (newFile: File) => {
        setError(null)
        // Only accept GEDCOM file types
        if (!allowedExtensions.includes(newFile.name.toLowerCase().slice(newFile.name.lastIndexOf(".")))) {
            setError(intl.formatMessage({id: "dropzone.upload.error.invalidExtension"}))
            return
        }
        // Check for empty
        if (newFile.size === 0) {
            setError(intl.formatMessage({id: "dropzone.upload.error.emptyFile"}))
            return
        }
        // Passed validations
        setFile(newFile)
    }

    return (
        <div className="ui upload-container">
            <div id="dropzone" className="ui" onClick={handleUploadClick} onDrop={handleUploadDrop} onDragOver={(e) => e.preventDefault()}>
                <input type="file" accept={allowedExtensions.join(",")} ref={fileInputRef} onChange={handleFileChange} style={{ display: "none" }}/>
                <p><FormattedMessage id="landing.column.dropzone.label"/></p>
                {error && <p id="upload-error"><span style={{ fontSize: "1.5rem" }}>🫥</span>&nbsp;&nbsp;{error}</p>}
                <Button><Icon name="upload"/><FormattedMessage id="landing.column.dropzone.button"/></Button>
            </div>
        </div>
    )
}